export default {
      id: "staff-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#staff",
      toString: function () {
        return this.url;
      }
    }